import {createStore, compose, applyMiddleware} from 'redux';
import reducers from './reducers';
import {loadState, saveState} from './localStorage';
import {routerMiddleware} from 'react-router-redux';
import _ from 'lodash';

const middleware = routerMiddleware( history );
const persistedState = loadState();

const store = createStore(
  reducers,
  persistedState,
  compose( applyMiddleware( middleware ) )
);

store.subscribe( _.throttle( () => {
  saveState( store.getState() );
} ), 1000 );

export default store;



// WEBPACK FOOTER //
// ./stores/index.js